const TYPES = new Set(['bullet', 'turret', 'dome', 'ptz', 'fisheye', 'multi-sensor', 'box']);
export function cameraAppearance(model = {}) {
  model ||= {};
  const type = TYPES.has(model.type) ? model.type : model.pano >= 360 ? 'fisheye' : 'box';
  // Library dimensions often include brackets or weather shields and do not
  // specify axis order. Use them only for a conservative overall size estimate.
  const reference = { bullet: 0.22, turret: 0.13, dome: 0.15, ptz: 0.3, fisheye: 0.15, 'multi-sensor': 0.24, box: 0.2 }[type];
  const dimension = String(model.dimensions || '');
  const values = /\bmm\b/i.test(dimension) ? (dimension.split('(')[0].match(/\d+(?:\.\d+)?/g) || []).map(Number).filter(v => v >= 30 && v <= 800) : [];
  const diameter = values.length ? Number(dimension.match(/[Ø⌀Φ]\s*(\d+(?:\.\d+)?)/i)?.[1]) : NaN;
  const size = ['turret', 'dome', 'fisheye', 'multi-sensor'].includes(type) && diameter >= 30 && diameter <= 800 ? diameter / 1000 : values.length ? Math.max(...values) / 1000 : reference;
  return { type, scale: Math.min(1.65, Math.max(0.65, size / reference)), dimensioned: !!values.length };
}
